export enum SETTINGS {
  TEAM_ID = "@wazai:teamId",
}
